export const RESPONSIVE_IMAGE_VERTEX = `
    varying vec2 vUv;

    void main() {
        vUv = uv;

        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const RESPONSIVE_IMAGE_FRAGMENT = `
    precision mediump float;

    #define PI 3.1415926538

    uniform float imageScale;
    uniform float maskScale;
    uniform float opacity;
    uniform float hover;
    uniform sampler2D texture1;
    uniform sampler2D texture2;
    uniform sampler2D textureOverlay;
    uniform sampler2D mask;
    uniform vec2 resolution;
    uniform vec2 mouse;

    varying vec2 vUv;

    uniform float darken;

    float scaleCenter = 0.5;

    void main() {
        vec2 uMouse = mouse * -0.5;
        // tip2: do the same for your mouse
        uMouse.y *= resolution.y / resolution.x;
        uMouse *= -1.;

        // Applies aspect ratio to plane
        vec2 newUV = (vUv - vec2(scaleCenter)) * resolution.xy + vec2(scaleCenter);
        vec2 mouseUv = vUv + uMouse;
        vec2 newUVMouse = (mouseUv - vec2(scaleCenter)) * resolution.xy + vec2(scaleCenter);

        // Gets new centered coords for the texture and scales the image
        vec2 textureUVScale = (newUV - scaleCenter) * 1. + scaleCenter;
        vec2 textureUVScaleMouse = (newUVMouse - scaleCenter) * imageScale + scaleCenter;
        vec2 maskUVScale = (newUV - scaleCenter) * maskScale + scaleCenter;

        // Gets texture pixel color
        vec4 textureColor = texture2D(texture1, textureUVScaleMouse);
        vec4 textureColorHover = texture2D(texture2, textureUVScaleMouse);
        vec4 textureBlack = texture2D(textureOverlay, textureUVScale);
        vec4 maskColor = texture2D(mask, maskUVScale);

        // Darkens video
        // vec4 darkened = mix(textureColor, textureBlack, darken);

        // Mixes with mask
        // vec4 maskedColor = darkened * maskColor; 

        // Hover texture
        vec4 textureHover = mix(textureColor, textureColorHover, hover);

        gl_FragColor = vec4(textureHover.rgb, textureHover.a * opacity);
    }
`;
